/**
 * RTWO Asset & Token Engine — Public API
 * Phase 14 | Module ID: RTWO-ASST-001
 * Version: 1.0.0-phase14
 *
 * Public exports for the RTWO Asset & Token Engine.
 * Import from this file for all Asset & Token Engine functionality.
 *
 * Truthful Data Policy:
 * - No fake assets, token supplies, holders, prices, transfers, or metadata.
 * - Tokens are NOT claimed as live or operational.
 *
 * Source: Asset & Token Engine (RTWO-ASST-001)
 */

// Domain Models
export type {
  AssetId,
  StandardId,
  PolicyId,
  PermissionId,
  RuleId,
  RecordId,
  EventId,
  MetadataId,
  ASSTimestamp,
  RTWOAssetEngineStatus,
  RTWOAssetType,
  RTWOAssetLifecycleStage,
  RTWOAssetDefinitionStatus,
  RTWOTokenStandardType,
  RTWOTokenStandardStatus,
  RTWOCompatibilityPolicy,
  RTWOSupplyType,
  RTWOMintingPolicy,
  RTWOBurningPolicy,
  RTWOSupplyPolicyStatus,
  RTWOAssetPermissionType,
  RTWOAssetPermissionStatus,
  RTWOTransferRuleType,
  RTWOTransferRuleStatus,
  RTWORegistryStatus,
  RTWOAssetEventType,
  RTWOAssetEventStatus,
  RTWOMetadataStatus,
  ASSEventType,
  ASSEventHandler,
  RTWOAssetDefinition,
  RTWOTokenStandard,
  RTWOAssetSupplyPolicy,
  RTWOAssetPermission,
  RTWOAssetTransferRule,
  RTWOAssetRegistryRecord,
  RTWOAssetEvent,
  RTWOTokenMetadata,
} from './domain-models';

export {
  ASST_ENGINE_VERSION,
  ASSET_ENGINE_STATUS_LABELS,
  ASSET_TYPE_LABELS,
  ASSET_TYPE_DESCRIPTIONS,
  ASSET_LIFECYCLE_LABELS,
  ASSET_LIFECYCLE_DESCRIPTIONS,
  TOKEN_STANDARD_STATUS_LABELS,
  RTWO_TOKEN_STANDARDS,
} from './domain-models';

// Service Interfaces
export type {
  ASSServiceStatus,
  ASSServiceDescriptor,
  ASSServiceRegistry,
  IASSService,
  IAssetRegistryService,
  AssetRegistryResult,
  ITokenStandardRegistryService,
  ISupplyPolicyService,
  SupplyPolicyResult,
  IPermissionService,
  PermissionResult,
  ITransferRuleService,
  TransferRuleResult,
  IMetadataService,
  MetadataResult,
  IAssetEventPublisherService,
  AssetEventPublishResult,
  IAssetValidationService,
  AssetValidationResult,
  IAssetReadinessService,
  ASSReadinessReport,
  ITokenLifecycleService,
  TokenLifecycleResult,
} from './service-interfaces';

// Engine
export type { RTWOAssetTokenEngine } from './asset-engine';
export { getAssetTokenEngine } from './asset-engine';
